import { memoize } from "lodash";
import { utilBalancing } from "../utils/utilBalancing";
export var selectBalancingBuffs = function () { return utilBalancing.getBalancing().Buffs; };
export var selectBalancingBuff = memoize(function (typeId) {
    if (typeId == undefined) {
        return undefined;
    }
    var buffs = selectBalancingBuffs();
    return buffs.get(typeId);
});
export var selectBalancingBuffFactorAddition = memoize(function (id) {
    var buffFactorAddition = 1;
    var buff = selectBalancingBuff(id);
    if (buff && buff.factorAddition) {
        buffFactorAddition += buff.factorAddition;
    }
    return buffFactorAddition;
});
// TODO - Use calculateBuffInfo
export var selectBalancingXPBuffFactor = memoize(function (id) {
    var buffFactor = 1;
    var buff = selectBalancingBuff(id);
    if (buff && buff.factorAddition) {
        buffFactor += buff.factorAddition;
    }
    return buffFactor;
});
export var balancingBuffMemoizedFunctions = [
    selectBalancingBuff,
    selectBalancingBuffFactorAddition,
    selectBalancingXPBuffFactor,
];



//////////////////
// WEBPACK FOOTER
// ./src/balancingSelectors/selectBalancingBuffs.ts
// module id = 231
// module chunks = 3